import i18n from "../../../i18n";

export const initialState = {
    i18n,
    transcriptionFile: [],
};

const state = { ...initialState };

export default state;